__turbopack_context__.v({
  "cardFlip": "BlockProducts-module-scss-module__vms1Ta__cardFlip",
  "cardInternalLink": "BlockProducts-module-scss-module__vms1Ta__cardInternalLink",
  "cardSlot": "BlockProducts-module-scss-module__vms1Ta__cardSlot",
  "fade-in": "BlockProducts-module-scss-module__vms1Ta__fade-in",
  "filler": "BlockProducts-module-scss-module__vms1Ta__filler",
  "fillerHideLarge": "BlockProducts-module-scss-module__vms1Ta__fillerHideLarge",
  "fillerHideSmall": "BlockProducts-module-scss-module__vms1Ta__fillerHideSmall",
  "fillerHideXXLarge": "BlockProducts-module-scss-module__vms1Ta__fillerHideXXLarge",
  "firstBlock": "BlockProducts-module-scss-module__vms1Ta__firstBlock",
  "hasMore": "BlockProducts-module-scss-module__vms1Ta__hasMore",
  "hideLarge": "BlockProducts-module-scss-module__vms1Ta__hideLarge",
  "hideSmall": "BlockProducts-module-scss-module__vms1Ta__hideSmall",
  "hideXXLarge": "BlockProducts-module-scss-module__vms1Ta__hideXXLarge",
  "isCollapsed": "BlockProducts-module-scss-module__vms1Ta__isCollapsed",
  "landscape": "BlockProducts-module-scss-module__vms1Ta__landscape",
  "listItem": "BlockProducts-module-scss-module__vms1Ta__listItem",
  "productList": "BlockProducts-module-scss-module__vms1Ta__productList",
  "root": "BlockProducts-module-scss-module__vms1Ta__root",
  "showMore": "BlockProducts-module-scss-module__vms1Ta__showMore",
  "showMoreLarge": "BlockProducts-module-scss-module__vms1Ta__showMoreLarge",
  "showMoreSmall": "BlockProducts-module-scss-module__vms1Ta__showMoreSmall",
  "showMoreXXLarge": "BlockProducts-module-scss-module__vms1Ta__showMoreXXLarge",
});
